import { VideoModes } from '../../config/video-modes';

export const tagging = {
  taggingId: {
    type: String,
    required: true,
  },
};

export const video = {
  headingLevel: {
    type: Number,
    default: 3,
  },
  heading: {
    type: String,
    required: false,
    default: null,
  },
  text: {
    type: String,
    required: false,
    default: null,
  },
  ctalink: {
    type: String,
    required: false,
    default: null,
  },
  ctatext: {
    type: String,
    required: false,
    default: null,
  },
  alignment: {
    type: String,
    required: false,
    default: 'center',
  },
  display: {
    type: Object,
    required: false,
    default: () => ({
      headingFont: 'sans',
      contentFont: 'serif',
    }),
  },
  loop: {
    type: Boolean,
    default: false,
  },
  autoplay: {
    type: Boolean,
    default: false,
  },
  muted: {
    type: Boolean,
    default: true,
  },
  /**
   * Sample source
   * {
   *   src: 'assets/video1.mp4',
   *   type: 'video/mp4',
   *   screenSize: 'sm',
   * }
   * Where screensizes are: sm (360p) | md (720p) | lg (1080p+)
   * NB: at present size entries MUST BE IN ASCENDING ORDER
   */
  sources: {
    required: false,
    validator(value) {
      return (
        Array.isArray(value) &&
        value.every((source) => ['src', 'type', 'screenSize'].every((key) => key in source))
      );
    },
  },
  controls: {
    type: Boolean,
    required: false,
    default: false,
  },
  poster: {
    type: String,
    required: false,
    default: '',
  },
};

export const playlist = {
  index: {
    type: String,
    required: false,
    default: null,
  },
  showVideoNumber: {
    type: Boolean,
    required: false,
    default: false,
  },
  autoplay: {
    type: Boolean,
    required: false,
    default: false,
  },
  aspectRatio: {
    type: String,
    required: false,
    default: '16-9',
    validator(value) {
      return ['16-9', '9-16', '4-5', '1-1'].includes(value);
    },
  },
  nowShowingLabel: {
    type: String,
    required: false,
    default: null,
  },
  titleLabel: {
    type: String,
    required: false,
    default: null,
  },
  items: {
    required: true,
    validator(value) {
      return (
        Array.isArray(value) &&
        value.every((source) =>
          [
            'index',
            'title',
            'description',
            'largeThumbnailImage',
            'smallThumbnailImage',
            'cta',
            'youtubeId',
            'internalVideoId',
          ].every((key) => key in source),
        )
      );
    },
  },
};

export const common = {
  mode: {
    type: String,
    default: VideoModes.VIDEO,
  },
};
